export const topMenu = {
  menuItems: [
    {
      label: 'Как это работает',
      component: 'ElectronicRegistration',
    },
    {
      label: 'Преимущества',
      component: 'ElectronicAdvantages',
    },
    // TODO: временно приняли решение убрать эту секцию
    // {
    //   label: 'Инструкция',
    //   component: 'ElectronicRequirement',
    // },
    {
      label: 'FAQ',
      component: 'ElectronicFAQ',
    },
    {
      label: 'Контакты ',
      component: 'FooterComponent',
    },
  ],
  pushToHome: 'На главную',
  pushToConsultation: 'Получить консультацию',
}

export const headerBlock = {
  image: 'header.png',
  title: 'Электронные транспортные  <br> накладные (ЭТрН)',
  subTitle: 'Быстро, просто, законно',
  description:
    'С 1 сентября 2026 года ЭТрН обязателен. Начните работать с электронными документами уже сегодня. Регистрация за 5 минут, подписание в один клик.',
  button: 'Узнать больше',
  buttonPresentation: 'Оставить заявку на демо',
}

export const electronicSuccessfullyCompletedData = {
  tiles: [
    {
      title: 'Т1',
      subtitle: 'Грузоотправитель',
      text: 'Создание ЭТрН и подписание КЭП',
      background: true,
      img: 'decision1.png',
    },
    {
      title: 'Т2',
      subtitle: 'Перевозчик',
      text: 'Подписание КЭП раздел о приеме груза к перевозке',
      background: true,
      img: 'decision2.png',
    },
    {
      title: 'Т3',
      subtitle: 'Грузополучатель',
      text: 'Подписание КЭП раздел о приеме груза к перевозке',
      background: true,
      img: 'decision3.png',
    },
    {
      title: 'Т4',
      subtitle: 'Перевозчик',
      text: 'Подписание КЭП финализация ЭТрН. Груз сдан',
      background: true,
      img: 'decision4.png',
    },
  ],
  info: {
    title: 'ЭТрН успешно оформлена',
    description:
      'После прохождения всех статусов перевозка считается завершенной.',
    details: '* Т1, Т2, Т3, Т4 — это титулы транспортной накладной.',
  },
}

export const electronicAdvantagesData = {
  title: 'Преимущества',
  tiles: [
    {
      title: 'Быстро',
      text: 'заполнение занимает 3 минуты (умная форма, автоподстановка данных)',
      img: '<svg width="118" height="118" viewBox="0 0 118 118" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M48.383 0.974301L48.0391 48.0397L0.973653 48.3836L48.383 0.974301Z" stroke="#4CC0CC" stroke-width="0.8"/><path d="M64.6466 17.238L64.3027 64.3034L17.2373 64.6473L64.6466 17.238Z" stroke="#4CC0CC" stroke-width="0.8"/><path d="M81.6173 34.2077L81.2734 81.2731L34.208 81.617L81.6173 34.2077Z" stroke="#4CC0CC" stroke-width="0.8"/><path d="M97.8805 50.4714L97.5366 97.5368L50.4712 97.8807L97.8805 50.4714Z" stroke="#4CC0CC" stroke-width="0.8"/></svg>',
    },
    {
      title: 'Просто',
      text: 'не нужно разбираться в XML - мы всё сделаем за вас',
      img: '<svg width="118" height="118" viewBox="0 0 118 118" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="34.7895" cy="38.0714" r="11.99" transform="rotate(38.9648 34.7895 38.0714)" stroke="#4CC0CC" stroke-width="0.8"/> <circle cx="36.7127" cy="40.3856" r="16.12" transform="rotate(38.9648 36.7127 40.3856)" stroke="#4CC0CC" stroke-width="0.8"/> <path d="M62.5272 25.3554C75.0292 35.4666 77.1216 53.5849 67.2249 65.8217C57.3281 78.0583 39.1728 79.801 26.6709 69.6899C14.1689 59.5787 12.0766 41.4603 21.9732 29.2235C31.8699 16.9867 50.0252 15.2441 62.5272 25.3554Z" stroke="#4CC0CC" stroke-width="0.8"/> <circle cx="53.4029" cy="55.4012" r="43.2599" transform="rotate(38.9648 53.4029 55.4012)" stroke="#4CC0CC" stroke-width="0.8"/> <circle cx="58.5773" cy="58.5773" r="50.4949" transform="rotate(38.9648 58.5773 58.5773)" stroke="#4CC0CC" stroke-width="0.8"/> <circle cx="48.7273" cy="50.8614" r="35.5899" transform="rotate(38.9648 48.7273 50.8614)" stroke="#4CC0CC" stroke-width="0.8"/><circle cx="40.4701" cy="44.1829" r="22.6099" transform="rotate(38.9648 40.4701 44.1829)" stroke="#4CC0CC" stroke-width="0.8"/></svg>',
    },
    {
      title: 'Мобильность',
      text: 'перевозчик может подписать документ прямо с телефона',
      img: '<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M88.4229 47.8145V57.4756H57.0381V88.8604H47.377V47.8145H88.4229Z" stroke="#4CC0CC" stroke-width="0.8"/> <path d="M71.5439 30.498V40.1592H40.1592V71.5439H30.498V30.498H71.5439Z" stroke="#4CC0CC" stroke-width="0.8"/> <path d="M105.739 64.6934V74.3545H74.3545V105.739H64.6934V64.6934H105.739Z" stroke="#4CC0CC" stroke-width="0.8"/> <path d="M54.4463 13.4004V23.0615H23.0615V54.4463H13.4004V13.4004H54.4463Z" stroke="#4CC0CC" stroke-width="0.8"/> </svg>',
    },
    {
      title: 'В мобильном приложении',
      text: 'можно подписывать при помощи КЭП',
      img: '<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M69.4864 108.005C90.1696 108.005 106.998 91.0623 106.998 70.2386C106.997 64.4349 105.667 58.7095 103.11 53.508C100.553 48.3065 96.8385 43.7692 92.2554 40.249C89.8 36.0955 86.5803 32.4517 82.7689 29.5128C79.4487 23.8751 74.7291 19.204 69.0735 15.9582C63.4179 12.7125 57.0209 11.0038 50.511 11C29.8278 11 12.9998 27.9423 12.9998 48.766C13.0001 54.5697 14.3305 60.2951 16.8874 65.4965C19.4444 70.698 23.1589 75.2354 27.742 78.7556C30.1987 82.9081 33.4182 86.5517 37.2285 89.4918C40.5486 95.1295 45.2683 99.8006 50.9239 103.046C56.5795 106.292 62.9765 108.001 69.4864 108.005ZM90.2743 38.8184C88.8797 37.881 87.4244 37.0385 85.9181 36.2966C85.364 34.7092 84.706 33.1606 83.9484 31.6609C86.3551 33.7618 88.4815 36.1676 90.2743 38.8184ZM32.8906 70.2271C32.8906 49.91 49.311 33.3781 69.4909 33.3781C74.921 33.3766 80.2826 34.5986 85.1826 36.9545C86.4633 40.7589 87.1149 44.7491 87.1114 48.766C87.1114 69.0831 70.6932 85.615 50.511 85.615C45.0792 85.6215 39.7149 84.4026 34.8125 82.0477C33.5326 78.2441 32.8818 74.2546 32.886 70.2385L32.8906 70.2271ZM33.6762 81.4608C31.84 80.499 30.0879 79.3823 28.4388 78.1228C25.1337 72.4771 23.3942 66.0419 23.4018 59.4885C23.4018 39.1692 39.8199 22.6395 60.0021 22.6395C67.9751 22.6315 75.7303 25.2589 82.0766 30.118C83.1239 31.9092 84.0182 33.7867 84.75 35.7303C79.9503 33.5692 74.751 32.4543 69.4932 32.4588C48.81 32.4588 31.982 49.4011 31.982 70.2248C31.9761 74.0394 32.5466 77.8327 33.6739 81.4746L33.6762 81.4608ZM50.5156 86.5183C71.1988 86.5183 88.0268 69.576 88.0268 48.7523C88.0292 44.943 87.458 41.1554 86.3326 37.5185C88.1682 38.4815 89.9202 39.5981 91.57 40.8566C94.8735 46.5028 96.6122 52.9378 96.6047 59.4908C96.6047 79.8079 80.1866 96.3398 60.0067 96.3398C52.0329 96.3481 44.2769 93.7208 37.9299 88.8614C36.8826 87.0701 35.9883 85.1926 35.2565 83.2491C40.0547 85.4136 45.2532 86.5324 50.511 86.5321L50.5156 86.5183ZM13.9107 48.766C13.9107 28.4467 30.3311 11.917 50.511 11.917C56.4846 11.9185 62.367 13.3925 67.6443 16.2104C72.9217 19.0282 77.4334 23.1042 80.7855 28.0822C74.6362 23.9366 67.4004 21.7275 59.9998 21.7363C39.3166 21.7363 22.4886 38.6786 22.4886 59.5023C22.4824 65.449 23.8786 71.3123 26.5624 76.6097C22.5911 73.1557 19.4055 68.8809 17.2223 64.0762C15.0391 59.2715 13.9096 54.0496 13.9107 48.766ZM29.7254 80.1747C31.1197 81.1126 32.575 81.9551 34.0815 82.6965C34.6337 84.2884 35.2917 85.8409 36.0512 87.3436C33.6445 85.2428 31.5182 82.8369 29.7254 80.1861L29.7254 80.1747ZM39.2119 90.9109C45.3625 95.0556 52.5987 97.2646 59.9998 97.2569C80.683 97.2569 97.5087 80.3145 97.5087 59.4908C97.5162 53.544 96.1199 47.6804 93.435 42.3834C97.4079 45.8385 100.595 50.1151 102.778 54.922C104.961 59.7288 106.09 64.953 106.087 70.2386C106.087 90.5533 89.6686 107.088 69.4864 107.088C63.5128 107.086 57.6304 105.612 52.3531 102.794C47.0757 99.9764 42.564 95.9004 39.2119 90.9224L39.2119 90.9109Z" fill="#4CC0CC"/> </svg>',
    },
    {
      title: 'Поддержка МЧД',
      text: 'можно подписывать документы, если оформлена машиночитаемая доверенность',
      img: '<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="14.5" y="14.5" width="91" height="91" stroke="#4CC0CC"/> <rect x="17.2598" y="17.2607" width="78.12" height="78.12" stroke="#4CC0CC"/> <rect x="20.02" y="20.0195" width="65.24" height="65.24" stroke="#4CC0CC"/> <rect x="23.7002" y="23.7002" width="52.36" height="52.36" stroke="#4CC0CC"/> <rect x="26.46" y="26.4609" width="39.48" height="39.48" stroke="#4CC0CC"/> <rect x="29.2202" y="29.2197" width="26.6" height="26.6" stroke="#4CC0CC"/> <rect x="31.98" y="31.9805" width="13.72" height="13.72" stroke="#4CC0CC"/> </svg>',
    },
  ],
}

export const electronicOverheadData = {
  clue: 'Что такое ЭТрН?',
  titleOne: 'Электронная транспортная накладная - ',
  titleTwo: 'это законный заменитель бумажной ТН, обязательный с ',
  titleThree: '1 сентября 2026.',
  description:
    'Документ хранится в ГИС ЭПД и доступен всем участникам перевозки в любое время.',
  button: 'Подробнее о 140-ФЗ',
}

export const electronicRegistrationData = {
  clue: 'Как это работает',
  titleOne:
    'Документооборот происходит через Минтранс. В течение перевозки все её участники видят ',
  titleTwo: 'статусы документов.',
}

export const electronicRequirementData = {
  clue: 'Требования к подписям',
  titleOne: 'Для подписания ЭТрН необходимы подписи',
  titleTwo: ' не ниже',
  titleThree: ' Рутокен 3.0 и/или Рутокен NFC.',
}
export const electronicHowStartedData = {
  clue: 'Как начать работу',
  titleOne: 'Для работы с ЭТрН доступны',
  titleTwo: ' инструкции',
  titleThree: ' по регистрации и оформлению накладных.',
}

export const electronicEmployeesData = {
  tiles: [
    {
      title: 'Руководитель',
      text: 'Большое скопление транспорта перед терминалом выгрузки',
      type: 'КЭП юрлица',
      where: 'УЦ (Рутокен, Контур, Астрал)',
      why: 'Чтобы самостоятельно подписывать ЭТрН',
    },
    {
      title: 'Сотрудник',
      text: 'Долгое ожидание выгрузки для транспорта',
      type: 'КЭП физлица + МЧД',
      where: 'КЭП - в УЦ, МЧД - в Контур.Доверенности',
      why: 'Чтобы сотрудник (логист, экспедитор) подписывал документы от лица компании',
      background: true,
    },
    {
      img: 'employees1.png',
    },
    {
      img: 'employees2.png',
    },
    {
      title: 'Водитель',
      text: 'Проблема с вызовом нужного транспорта / сырья на выгрузку',
      type: 'ПЭП (простая электронная подпись)',
      where: 'В приложении ЭТрН',
      why: 'Чтобы подтверждать погрузку/выгрузку',
    },
    {
      title: 'Водитель с правом подписи ЭТрН',
      text: 'Простой терминала и неравномерная нагрузка',
      type: 'КЭП физлица + МЧД',
      where: 'КЭП - в УЦ, МЧД - в Контур.Доверенности',
      why: 'Чтобы водитель подписывал ЭТрН от лица компании',
    },
  ],
}

export const formBlockConsultation = {
  titleOne: 'Оставьте заявку',
  titleTwo: ' на демо или получите консультацию по ЭТрН',
  description:
    'Вы можете получить демо системы и консультацию — расскажем про внедрение и подберем решение под ваш бизнес.',
}
// данные для самой формы
export const formData = {
  placeholders: {
    name: 'Как к вам обращаться *',
    phone: 'Номер телефона *',
    email: 'Почта',
    comment: 'Комментарий',
  },
  button: 'Отправить',
  checkbox: {
    textOne: 'Я ознакомлен(а) и согласен(на) с ',
    textTwo: ' и ',
    textThree:
      ' Даю согласие на обработку моих пероснальных данных для консультирования и обработки заявки.',
    textPresentation: 'Не хочу чтобы мне звонили',
    link: 'Политикой конфиденциальности',
    linkTwo: 'Согласием на обработку ПД.',
    url: '/legal/policy.pdf',
    urlTwo: '/legal/agreement.pdf',
  },
}

export const freeBlock = {
  left: {
    titleOne: 'Бесплатный',
    titleTwo: ' тестовый период',
    descriptionTop:
      'Для компаний которые осуществляют рейсы на КСК, во время проведения тестов подписание ЭТрН бесплатно.',
    button: 'Оставить заявку на демо',
    descriptionBottom:
      'Вы можете протестировать весь процесс: создание, подписание, отправку в ГИС ЭПД.',
  },
  right: {
    img: 'freePeriod.png',
  },
}

export const electronicTransitionData = {
  title: 'Готовы перейти на электронные накладные?',
  description:
    'Покажем ЭТрН в работе и поможем Вам быстро начать без лишних сложностей.',
  button: 'Оставить заявку на демо',
}

export const electronicFAQData = {
  title: 'FAQ',
  content: [
    {
      id: 1,
      title: 'Отменяет ли ЭТрН бумажную версию?',
      description:
        'Да, полностью. ЭТрН заменяет бумажную транспортную накладную и не требует дополнительного дублирования на бумаге. Документ хранится в ГИС ЭПД и доступен всем участникам перевозки в любое время.',
    },
    {
      id: 2,
      title: 'Кто должен использовать ЭТрН?',
      description:
        'ЭТрН обязаны применять все участники перевозки: грузоотправители, перевозчики (транспортные компании), грузополучатели. Если один из контрагентов отказывается от электронного документооборота, все участники цепочки вынуждены применять бумажные накладные.',
    },
    {
      id: 3,
      title: 'Нужно ли оформлять ЭТрН при самовывозе?',
      description:
        'Нет. Если покупатель перевозит товар собственным транспортом, оформлять ЭТрН не требуется. Документ необходим только при привлечении стороннего перевозчика.',
    },
    {
      id: 4,
      title: 'Что такое Т1 и Т2 в ЭТрН?',
      description:
        'Т1 (Титул 1) - это часть электронной транспортной накладной, которую заполняет и подписывает грузоотправитель. В ней указываются: грузоотправитель, перевозчик, грузополучатель, описание груза, маршрут, дата и время погрузки. Т2 (Титул 2) - это часть, которую подписывает перевозчик (водитель или уполномоченное лицо или водитель при наличии доверенности). В ней подтверждается факт принятия груза к перевозке. Оба титула подписываются электронной подписью (КЭП).',
    },
    {
      id: 5,
      title: 'Чем отличается Т1 от Т2?',
      description:
        'Т1 создает грузоотправитель - он инициирует перевозку, заполняет данные о грузе и маршруте. Т2 подписывает перевозчик - он подтверждает, что груз принят, состояние груза соответствует заявленному, и перевозка началась. Без подписанного Т2 перевозка не может быть начата, а без Т1 - не может быть создана.',
    },
    {
      id: 6,
      title: 'Что такое Т3, Т4, Т5, Т6, Т7, Т8?',
      description:
        'ЭТрН состоит из 8 титулов: Т1 - грузоотправитель, Т2 - перевозчик (прием груза), Т3 — грузополучатель (приемка груза), Т4 - перевозчик (подтверждение сдачи груза), Т5 и Т6 - исправления и корректировки, Т7 - переадресация груза, Т8 - замена водителя или транспортного средства. Первые четыре титула (Т1-Т4) - обязательны. Остальные заполняются при необходимости.',
    },
    {
      id: 7,
      title: 'Кто должен подписывать Т1 и Т2?',
      description:
        'Т1 подписывает грузоотправитель (или его уполномоченный сотрудник по доверенности). Т2 подписывает перевозчик (руководитель транспортной компании, сотрудник по доверенности или сам водитель, если у него есть электронная подпись и доверенность).',
    },
    {
      id: 8,
      title: 'Как ГИБДД проверяет ЭТрН?',
      description:
        'С 1 сентября 2022 года сотрудники ГИБДД проверяют электронные документы через специальное ПО на планшетах. Водитель показывает в приложении динамический QR-код, инспектор сканирует его и видит все данные о перевозке. QR-код защищён подписью ГИС ЭПД, поэтому его невозможно подделать.',
    },
    {
      id: 9,
      title: 'Нужно ли водителю иметь интернет, чтобы показать QR-код?',
      description:
        'Нет. Сформированный QR-код сохраняется в приложении и доступен для просмотра даже без подключения к интернету.',
    },
    {
      id: 10,
      title:
        'Если происходит переадресовка или замена водителя, нужно платить отдельно?',
      description:
        'Нет. Дополнительные титулы (Т7 - переадресация, Т8 - замена водителя) входят в тот же документ. Все участники платят один раз за документ в целом, даже если подписывают несколько титулов.',
    },
    {
      id: 11,
      title:
        'Что делать, если мои контрагенты подключены к другому оператору ЭДО?',
      description:
        'Современные операторы поддерживают роуминг - обмен документами между разными системами. Например, пользователи нашей Платформы ЭПД могут обмениваться документами с пользователями Контура, СБИС, Астрал и других операторов.',
    },
  ],
}

export const footerBlock = {
  title: 'Контакты',
  address: {
    title: 'Адрес:',
    value:
      '121205, город Москва, Внутренний территориальный городской муниципальный округ Можайский, тер. Сколково инновационного центра, б-р Большой, д. 42, стр. 1, пом. 138',
  },
  phone: {
    title: 'Телефон:',
    value: '<a href="tel:+79883234646">+7 (988) 323-46-46</a>',
  },
  email: {
    title: 'Email:',
    value:
      '<a href="mailto:skuzmichev@port-tranzit.ru">skuzmichev@port-tranzit.ru</a>',
  },
  map: 'footer-map.png',
  copyright: 'ООО «Порт Транзит». Все права защищены.',
  policy:
    '<a href="/legal/policy.pdf" target="_blank">Политика конфиденциальности</a>',
}
